<template>
  <v-dialog hide-overlay persistent width="300" v-model="show">
    <v-card color="primary" dark>
      <v-card-text>
        Loading please wait...
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['show'],
};
</script>
